import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { SearchParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Search Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  search: SearchParticleSpec.generateSchema("Search", "The embedded search widget."),
}));
